export const environment = {
  production: false,
  appUrls: {
    onboard: "https://onboard-dev.chareety.com",
    partners: "https://partners-dev.chareety.com",
    myChareety: "https://my-dev.chareety.com",
    orgConsole: "https://console-dev.chareety.com",
    marketing: "https://dev.chareety.com",
  },
  firebaseConfig: {
    apiKey: "AIzaSyDVKdKB4ywFpJbgk0eitXVwG7YeSjwGCa4",
    authDomain: "chareety-dev-4.firebaseapp.com",
    projectId: "chareety-dev-4",
    storageBucket: "chareety-dev-4.firebasestorage.app",
    messagingSenderId: "768587471920",
    appId: "1:768587471920:web:8756a42ca7b0338a9fa1f5",
    measurementId: "G-061S2PCY0Z"
  },
  //googleMapsApiKey: "AIzaSyAG76DLwya8JJ2tyggjlueu71AEbQZ3K_U",
  googleMapsApiKey: "AIzaSyCrWUmhRHanIE1rUnwYKoGdG8wk9fHbXcE",
  // App Check: reCAPTCHA v3 site key (unused in dev — debug token takes over)
  recaptchaSiteKey: "6LcEX74sAAAAAIn7vFof_fti905iLPeyIR0LzVx2",
  // Auto-registered App Check debug token (set by Ops/register-app.js).
  // DO NOT commit a real production token here.
  // Set by Ops/register-app.js — do not edit manually.
  // This token is pre-registered in Firebase App Check so dev builds work
  // without any Firebase Console steps.
  appCheckDebugToken: "82d2c714-07fa-4f62-a5be-d29c2e462437",
};
